"use client";

import {
    IoBookOutline,
    IoCreateOutline,
    IoEarOutline,
    IoHandLeftOutline,
} from "react-icons/io5";

type CapacityPercentInput = {
    skillListeningSpeaking: number | null;
    skillLangNature: number | null;
    skillReading: number | null;
    skillWriting: number | null;
};

function formatCapacityValue(value: number | null) {
    if (value === null) {
        return "-";
    }

    return `${value}%`;
}

type CapacityPercentCardsProps = {
    capacityPercent: CapacityPercentInput;
    className?: string;
};

export default function CapacityPercentCards({ capacityPercent, className = "" }: CapacityPercentCardsProps) {
    return (
        <div className={`grid grid-cols-2 gap-4 ${className}`}>
            <div className="rounded-xl bg-[#E1FFD8] px-4 py-3.5">
                <div className="flex items-center gap-3">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#5CD039] text-white">
                        <IoEarOutline size={22} />
                    </span>
                    <p className="text-xl leading-none font-bold text-[#000000]">
                        {formatCapacityValue(capacityPercent.skillListeningSpeaking)}
                    </p>
                </div>
                <p className="mt-2 text-base leading-tight font-normal text-[#000000]">การฟัง การดู และการพูด</p>
            </div>

            <div className="rounded-xl bg-[#D9EFFF] px-4 py-3.5">
                <div className="flex items-center gap-3">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#7BC8FF] text-white">
                        <IoBookOutline size={20} />
                    </span>
                    <p className="text-xl leading-none font-bold text-[#000000]">
                        {formatCapacityValue(capacityPercent.skillReading)}
                    </p>
                </div>
                <p className="mt-2 text-base leading-tight font-normal text-[#000000]">การอ่าน</p>
            </div>

            <div className="rounded-xl bg-[#FFE2D5] px-4 py-3.5">
                <div className="flex items-center gap-3">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#FFA27B] text-white">
                        <IoCreateOutline size={20} />
                    </span>
                    <p className="text-xl leading-none font-bold text-[#000000]">
                        {formatCapacityValue(capacityPercent.skillWriting)}
                    </p>
                </div>
                <p className="mt-2 text-base leading-tight font-normal text-[#000000]">การเขียน</p>
            </div>

            <div className="rounded-xl bg-[#FFDDE4] px-4 py-3.5">
                <div className="flex items-center gap-3">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#FF96AC] text-white">
                        <IoHandLeftOutline size={20} />
                    </span>
                    <p className="text-xl leading-none font-bold text-[#000000]">
                        {formatCapacityValue(capacityPercent.skillLangNature)}
                    </p>
                </div>
                <p className="mt-2 text-base leading-tight font-normal text-[#000000]">การเข้าใจและการนำไปใช้</p>
            </div>
        </div>
    );
}
